import React from 'react';
interface IconTooltipProps {
  label: string;
  children: React.ReactNode;
}

/**
 * Instant, styled tooltip shown above its target on hover and keyboard focus.
 * Replaces the browser's native `title` bubble, which is slow and unstyled.
 */
export function IconTooltip({
  label,
  children
}: IconTooltipProps) {
  return <span className="relative inline-flex group/tip" data-id="element-1993" data-mp="2xttnqvix1aau">
      <span tabIndex={0} aria-label={label} onClick={e => e.stopPropagation()} className="inline-flex rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4F46E5]" data-id="element-1994" data-mp="2tt1ei2a1n5ek">
        {children}
      </span>
      <span role="tooltip" className="pointer-events-none absolute bottom-full left-1/2 z-30 mb-2 -translate-x-1/2 scale-95 whitespace-nowrap rounded-lg bg-[#0F172A] px-2.5 py-1.5 text-[11px] font-semibold leading-none tracking-wide text-white opacity-0 shadow-lg shadow-slate-900/20 ring-1 ring-white/10 transition-[opacity,transform] duration-100 ease-out group-hover/tip:scale-100 group-hover/tip:opacity-100 group-focus-within/tip:scale-100 group-focus-within/tip:opacity-100" data-id="element-1995" data-mp="2k3q7cl6pwatb">
        {label}
        <span aria-hidden="true" className="absolute left-1/2 top-full h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 rotate-45 rounded-[1px] bg-[#0F172A]" data-id="element-1996" data-mp="3hplm5ildn43e" />
      </span>
    </span>;
}